import React from 'react';

export interface DetailTab {
  id: string;
  label: string;
  key: string;
}

/** Tab set rendered for WAREHOUSE quotes — Dray, Warehouse, and Delivery
 *  pull from transloadquote / deliveryquote. */
// eslint-disable-next-line react-refresh/only-export-components -- static tab definitions shared with the detail host
export const WAREHOUSE_TABS: DetailTab[] = [
  { id: 'cust',  label: 'Customer Info', key: 'U' },
  { id: 'dray',  label: 'Dray',          key: 'R' },
  { id: 'whse',  label: 'Warehouse',     key: 'W' },
  { id: 'deliv', label: 'Delivery',      key: 'L' },
  { id: 'docs',  label: 'Documents',     key: 'O' },
  { id: 'notes', label: 'Notes',         key: 'N' },
  { id: 'hist',  label: 'History',       key: 'H' },
];

/** Tab set rendered for DIRECT quotes — one Direct tab in place of Dray +
 *  Warehouse, and no Delivery (directquote carries the delivery destination
 *  inline). */
export const DIRECT_TABS: DetailTab[] = [
  { id: 'cust',   label: 'Customer Info', key: 'U' },
  { id: 'direct', label: 'Direct',        key: 'I' },
  { id: 'docs',   label: 'Documents',     key: 'O' },
  { id: 'notes',  label: 'Notes',         key: 'N' },
  { id: 'hist',   label: 'History',       key: 'H' },
];

/** Legacy export retained for callers that haven't been type-narrowed yet. */
export const QUOTE_DETAIL_TABS = WAREHOUSE_TABS;

interface Props {
  active: string;
  onChange: (id: string) => void;
  tabs?: DetailTab[];
}

/** Tab strip used inside Quote Detail page (below the header card). Pass
 *  `tabs={WAREHOUSE_TABS}` or `tabs={DIRECT_TABS}` to switch on quote type. */
const QuoteDetailTabs: React.FC<Props> = ({ active, onChange, tabs = WAREHOUSE_TABS }) => {
  return (
    <div className="bg-panel border-b border-slate-300 dark:border-gray-700 px-[18px] pt-1.5 flex gap-0.5 items-end flex-shrink-0">
      {tabs.map((t) => {
        const isActive = active === t.id;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            className={[
              'inline-flex items-center gap-1.5 px-4 py-2 text-[0.78125rem] cursor-pointer whitespace-nowrap',
              'border border-slate-300 rounded-t-md -mb-px',
              isActive
                ? 'text-slate-800 dark:text-slate-100 font-semibold bg-[#f5f6f8] border-b-[#f5f6f8] dark:bg-gray-800 dark:border-b-gray-800'
                : 'text-slate-500 dark:text-slate-400 font-medium bg-slate-200/60 hover:bg-slate-200',
            ].join(' ')}
          >
            <span className="text-[0.625rem] text-slate-400 font-medium">[{t.key}]</span>
            {' '}{t.label}
          </button>
        );
      })}
    </div>
  );
};

export default QuoteDetailTabs;
